import { Table } from "@freightsimple/ui-core/Table/Table";
import type { PaymentsInvoiceTableRow } from "./PaymentsInvoiceColumns";
import { paymentsInvoiceColumns } from "./PaymentsInvoiceColumns";

interface PaymentsMakePaymentsInvoicesTableProps {
  rows: PaymentsInvoiceTableRow[];
  /** Only read on first mount — the flow remounts per open, so that's enough. */
  initialSelectedInvoiceIds: Set<string>;
  onSelectionChange: (selectedInvoiceIds: Set<string>) => void;
  /** The filter text that decided which rows are shown — changing it returns to page 1. */
  filterQuery: string;
  emptyMessage: string;
}

const columns = [
  paymentsInvoiceColumns.charge(),
  paymentsInvoiceColumns.status(),
  paymentsInvoiceColumns.route(),
  paymentsInvoiceColumns.due(),
  paymentsInvoiceColumns.amount(),
];

/**
 * The Make Payments invoice picker: every payable invoice, selectable via the
 * table's own checkboxes. Due soonest first, so the invoices that restore
 * booking sit at the top — the flow pre-selects the overdue ones.
 */
export function PaymentsMakePaymentsInvoicesTable({
  rows,
  initialSelectedInvoiceIds,
  onSelectionChange,
  filterQuery,
  emptyMessage,
}: PaymentsMakePaymentsInvoicesTableProps) {
  return (
    <Table
      tableId="make-payments-invoices"
      columns={columns}
      data={rows}
      rowKey={(row) => row.invoice.invoiceId}
      selectable
      initialSelectedKeys={initialSelectedInvoiceIds}
      onSelectionChange={onSelectionChange}
      defaultSortKey="due"
      defaultSortDir="asc"
      resetPageKey={filterQuery}
      emptyMessage={emptyMessage}
    />
  );
}
